/**
 * 프론트엔드에 나오는 모든 자격증명을 한글로 자동 매핑하는 통합 시스템
 * 
 * 기능:
 * 1. 포괄적인 자격증명 한글 매핑
 * 2. 동적 매핑 규칙 적용
 * 3. 자격증 분류별 표준화
 * 4. 자동 매핑 실패 시 지능형 변환
 * 5. 사용자 정의 매핑 추가 가능
 */

// 메인 한글 매핑 테이블 (확장된 버전)
export const KOREAN_NAME_MAPPING = {
  // =============================================================================
  // 전기/전자 관련 자격증
  // =============================================================================
  'electrical-engineer': '전기기사',
  'electrical-industrial-engineer': '전기산업기사', 
  'electrical-construction-engineer': '전기공사기사',
  'electrical-technician': '전기기능사',
  'electronics-engineer': '전자기사',
  'electronics-industrial-engineer': '전자산업기사',
  'electronics-technician': '전자기능사',
  'power-engineer': '전력기사',
  'power-technician': '전력기능사',
  'electrical-control-engineer': '전기제어기사',
  'electrical-communication-engineer': '전기통신기사',
  'electrical-communication-technician': '전기통신기능사',
  
  // =============================================================================
  // IT/컴퓨터 관련 자격증
  // =============================================================================
  'information-processing-engineer': '정보처리기사',
  'information-processing': '정보처리기사',
  'information-processing-technician': '정보처리기능사',
  'computer-applications-level1': '컴활1급',
  'computer-applications-level2': '컴활2급', 
  'computer-applications-specialist-level1': '컴퓨터활용능력 1급',
  'computer-applications-specialist-level2': '컴퓨터활용능력 2급',
  'network-engineer': '네트워크관리사',
  'database-engineer': '데이터베이스관리사',
  'web-designer': '웹디자인기능사',
  'multimedia-content-creator': '멀티미디어콘텐츠제작전문가',
  'information-security-engineer': '정보보안기사',
  'information-security-technician': '정보보안기능사',
  
  // =============================================================================
  // 건축/토목 관련 자격증
  // =============================================================================
  'architectural-engineer': '건축기사',
  'construction-engineer': '건축기사',
  'architectural-technician': '건축기능사',
  'civil-engineer': '토목기사',
  'civil-technician': '토목기능사',
  'building-equipment-engineer': '건축설비기사',
  'interior-architecture-engineer': '실내건축기사',
  'landscape-architecture-engineer': '조경기사',
  'urban-planning-engineer': '도시계획기사',
  'construction-safety-engineer': '건설안전기사',
  
  // =============================================================================
  // 기계 관련 자격증  
  // =============================================================================
  'mechanical-engineer': '기계기사',
  'mechanical-technician': '기계기능사',
  'mechanical-design-engineer': '기계설계기사',
  'hvac-refrigeration-industrial-engineer': '공조냉동기계산업기사',
  'hvac-refrigeration-engineer': '공조냉동기계기사',
  'refrigeration-engineer': '냉동기계기사',
  'refrigeration-technician': '냉동기계기능사',
  'boiler-engineer': '보일러기사',
  'boiler-technician': '보일러기능사',
  'welding-engineer': '용접기사',
  'welding-technician': '용접기능사',
  'automobile-engineer': '자동차정비기사',
  'automobile-technician': '자동차정비기능사',
  
  // =============================================================================
  // 화학/위험물 관련 자격증
  // =============================================================================
  'hazardous-materials-industrial-engineer': '위험물산업기사',
  'hazardous-materials-engineer': '위험물기사',
  'hazardous-materials-technician': '위험물기능사',
  'chemical-engineer': '화학분석기사',
  'chemical-technician': '화학분석기능사',
  'environmental-engineer': '환경기사',
  'environmental-technician': '환경기능사',
  'water-treatment-engineer': '수질환경기사',
  'air-pollution-engineer': '대기환경기사',
  
  // =============================================================================
  // 안전 관련 자격증
  // =============================================================================
  'fire-engineer': '소방설비기사',
  'fire-engineer-mechanic': '소방설비기사(기계분야)',
  'fire-protection-engineer-electrical': '소방설비기사(전기분야)',
  'fire-technician': '소방설비기능사',
  'industrial-safety-engineer': '산업안전기사',
  'industrial-safety-technician': '산업안전기능사',
  'industrial-hygiene-engineer': '산업위생관리기사',
  'construction-safety-technician': '건설안전기능사',
  'health-safety-engineer': '산업보건기사',
  'gas-safety-engineer': '가스안전기사',
  'dangerous-goods-safety-engineer': '위험물안전관리기사',
  
  // =============================================================================
  // 운전/조작 관련 자격증
  // =============================================================================
  'forklift-operator-technician': '지게차운전기능사',
  'forklift-operator': '지게차운전기능사',
  'excavator-operator': '굴착기운전기능사',
  'excavator-operator-technician': '굴착기운전기능사',
  'crane-operator': '기중기운전기능사',
  'bulldozer-operator': '불도저운전기능사',
  'loader-operator': '로더운전기능사',
  'motor-grader-operator': '모터그레이더운전기능사',
  'tower-crane-operator': '타워크레인신호수',
  
  // =============================================================================
  // 가스 관련 자격증
  // =============================================================================
  'gas-engineer': '가스기사',
  'gas-industrial-engineer': '가스산업기사',
  'gas-technician': '가스기능사',
  'gas-safety-technician': '가스안전기능사',
  'lpg-engineer': 'LPG기사',
  'city-gas-engineer': '도시가스기사',
  
  // =============================================================================
  // 요리/제과제빵/서비스 관련 자격증
  // =============================================================================
  'korean-cooking-technician': '한식조리기능사',
  'chinese-cooking-technician': '중식조리기능사',
  'japanese-cooking-technician': '일식조리기능사',
  'western-cooking-technician': '양식조리기능사',
  'confectionery-technician': '제과기능사',
  'bakery-technician': '제빵기능사',
  'barista-technician': '바리스타기능사',
  'bartender-technician': '조주기능사',
  'food-processing-technician': '식품가공기능사',
  'nutrition-teacher': '영양교사',
  'cooking-teacher': '조리교사',
  'hotel-management': '호텔경영사',
  'tourism-guide': '관광안내사',
  'beautician-technician': '미용기능사',
  'hairdressing-technician': '미용기능사',
  'nail-art-technician': '네일아트기능사',
  'skin-care-technician': '피부미용기능사',
  
  // =============================================================================
  // 산림/농업/환경 관련 자격증
  // =============================================================================
  'forest-technician': '산림기능사',
  'forest-engineer': '산림기사',
  'forest-industrial-engineer': '산림산업기사',
  'agriculture-engineer': '농업기사',
  'agriculture-technician': '농업기능사',
  'horticulture-engineer': '원예기사',
  'horticulture-technician': '원예기능사',
  'landscaping-technician': '조경기능사',
  'pesticide-engineer': '농약관리사',
  'seed-engineer': '종자기사',
  
  // =============================================================================
  // 특수 분야 자격증
  // =============================================================================
  'radiation-safety-engineer': '방사선안전관리기사',
  'nuclear-engineer': '원자력기사',
  'meteorology-engineer': '기상기사',
  'survey-engineer': '측량기사',
  'survey-technician': '측량기능사',
  'materials-engineer': '재료기사',
  'quality-engineer': '품질관리기사',
  'packaging-engineer': '포장기사',
  'textile-engineer': '섬유기사',
  'fashion-design-technician': '패션디자인기능사',
  'jewelry-technician': '귀금속가공기능사',
  'watch-repair-technician': '시계수리기능사',
  'optical-technician': '안경광학기능사',
  
  // =============================================================================
  // 운송/물류 관련 자격증
  // =============================================================================
  'logistics-engineer': '물류관리사',
  'port-logistics-engineer': '항만물류관리사',
  'distribution-manager': '유통관리사',
  'customs-broker': '관세사',
  'freight-forwarder': '국제물류사',
  
  // =============================================================================
  // 금융/경영 관련 자격증
  // =============================================================================
  'accounting-technician': '회계관리기능사',
  'tax-accountant': '세무사',
  'financial-planner': '재무설계사',
  'insurance-planner': '보험설계사',
  'real-estate-agent': '공인중개사',
  'securities-investment-advisor': '투자상담사',
  
  // =============================================================================
  // 예술/문화 관련 자격증
  // =============================================================================
  'cultural-heritage-repair-technician': '문화재수리기능사',
  'traditional-building-technician': '한식목공기능사',
  'ceramics-technician': '도자기공예기능사',
  'metalwork-technician': '금속공예기능사',
  'woodwork-technician': '목공예기능사',
  'printing-technician': '인쇄기능사',
  'photography-technician': '사진기능사',
  'video-production-technician': '영상제작기능사',
  
  // =============================================================================
  // 의료/보건 관련 자격증
  // =============================================================================
  'medical-technician': '의료기기기능사',
  'dental-technician': '치과기공사',
  'dental-hygienist': '치과위생사',
  'optician': '안경사',
  'physical-therapist': '물리치료사',
  'occupational-therapist': '작업치료사',
  'radiologic-technologist': '방사선사',
  'clinical-pathologist': '임상병리사',
  'emergency-medical-technician': '응급구조사',
  
  // =============================================================================
  // 교육 관련 자격증
  // =============================================================================
  'kindergarten-teacher': '유치원교사',
  'elementary-teacher': '초등교사',
  'secondary-teacher': '중등교사',
  'special-education-teacher': '특수교사',
  'librarian': '사서',
  'social-worker': '사회복지사',
  'youth-counselor': '청소년상담사',
  
  // =============================================================================
  // 스포츠/레저 관련 자격증
  // =============================================================================
  'sports-instructor': '생활스포츠지도사',
  'fitness-trainer': '건강운동관리사',
  'swimming-instructor': '수영지도사',
  'skiing-instructor': '스키지도사',
  'climbing-instructor': '산악지도사',
  'marine-sports-instructor': '해양스포츠지도사',
  'golf-instructor': '골프지도사',
  'taekwondo-instructor': '태권도지도사',
  
  // =============================================================================
  // 언어 관련 자격증
  // =============================================================================
  'korean-language-teacher': '한국어교원',
  'interpreter': '통역사',
  'translator': '번역사',
  'tour-interpreter': '관광통역안내사',
  'english-conversation-instructor': '영어회화지도사',
  
  // =============================================================================
  // 일반적인 변형 패턴들
  // =============================================================================
  'technician': '기능사',
  'engineer': '기사',
  'industrial-engineer': '산업기사',
  'specialist': '전문가',
  'manager': '관리사',
  'instructor': '지도사',
  'teacher': '교사',
  'advisor': '상담사',
  'consultant': '컨설턴트'
};

// 자격증 분류 카테고리
export const CERTIFICATION_CATEGORIES = {
  electrical: '전기/전자',
  it: 'IT/컴퓨터',
  construction: '건축/토목',
  mechanical: '기계',
  chemical: '화학/환경',
  safety: '안전관리',
  transportation: '운전/조작',
  gas: '가스',
  service: '서비스/요리',
  agriculture: '농림/환경',
  special: '특수기술',
  logistics: '물류/운송',
  finance: '금융/경영',
  culture: '문화/예술',
  medical: '의료/보건',
  education: '교육',
  sports: '체육/레저',
  language: '어학'
};

// 동적 매핑 규칙
const DYNAMIC_MAPPING_RULES = [
  // 기능사 패턴
  {
    pattern: /(.+)-technician$/,
    transform: (match) => `${match[1].replace(/-/g, '')}기능사`
  },
  // 기사 패턴
  {
    pattern: /(.+)-engineer$/,
    transform: (match) => `${match[1].replace(/-/g, '')}기사`
  },
  // 산업기사 패턴
  {
    pattern: /(.+)-industrial-engineer$/,
    transform: (match) => `${match[1].replace(/-/g, '')}산업기사`
  },
  // 레벨 패턴
  {
    pattern: /(.+)-level([12])$/,
    transform: (match) => `${match[1].replace(/-/g, '')} ${match[2]}급`
  },
  // 매니저/관리사 패턴
  {
    pattern: /(.+)-manager$/,
    transform: (match) => `${match[1].replace(/-/g, '')}관리사`
  },
  // 지도사 패턴
  {
    pattern: /(.+)-instructor$/,
    transform: (match) => `${match[1].replace(/-/g, '')}지도사`
  }
];

// 영어 단어 → 한국어 변환 사전
const ENGLISH_TO_KOREAN_DICT = {
  electrical: '전기',
  electronic: '전자',
  electronics: '전자',
  mechanical: '기계',
  civil: '토목',
  construction: '건설',
  building: '건축',
  architectural: '건축',
  chemical: '화학',
  industrial: '산업',
  safety: '안전',
  fire: '소방',
  gas: '가스',
  information: '정보',
  processing: '처리',
  computer: '컴퓨터',
  network: '네트워크',
  database: '데이터베이스',
  web: '웹',
  multimedia: '멀티미디어',
  security: '보안',
  environment: '환경',
  water: '수질',
  air: '대기',
  pollution: '오염',
  health: '보건',
  automobile: '자동차',
  forklift: '지게차',
  excavator: '굴착기',
  crane: '크레인',
  welding: '용접',
  boiler: '보일러',
  refrigeration: '냉동',
  hvac: '공조냉동',
  materials: '재료',
  quality: '품질',
  packaging: '포장',
  textile: '섬유',
  fashion: '패션',
  jewelry: '귀금속',
  watch: '시계',
  optical: '광학',
  korean: '한식',
  chinese: '중식',
  japanese: '일식',
  western: '양식',
  confectionery: '제과',
  bakery: '제빵',
  barista: '바리스타',
  bartender: '조주',
  food: '식품',
  cooking: '조리',
  nutrition: '영양',
  hotel: '호텔',
  tourism: '관광',
  beauty: '미용',
  nail: '네일',
  skin: '피부',
  forest: '산림',
  agriculture: '농업',
  horticulture: '원예',
  landscape: '조경',
  pesticide: '농약',
  seed: '종자',
  radiation: '방사선',
  nuclear: '원자력',
  meteorology: '기상',
  survey: '측량',
  logistics: '물류',
  port: '항만',
  distribution: '유통',
  customs: '관세',
  freight: '국제물류',
  accounting: '회계',
  tax: '세무',
  financial: '재무',
  insurance: '보험',
  estate: '부동산',
  securities: '증권',
  investment: '투자',
  cultural: '문화',
  heritage: '문화재',
  traditional: '전통',
  ceramics: '도자기',
  metal: '금속',
  wood: '목재',
  printing: '인쇄',
  photography: '사진',
  video: '영상',
  medical: '의료',
  dental: '치과',
  physical: '물리',
  occupational: '작업',
  radiologic: '방사선',
  clinical: '임상',
  emergency: '응급',
  kindergarten: '유치원',
  elementary: '초등',
  secondary: '중등',
  special: '특수',
  library: '도서관',
  social: '사회',
  youth: '청소년',
  sports: '스포츠',
  fitness: '건강',
  swimming: '수영',
  skiing: '스키',
  climbing: '산악',
  marine: '해양',
  golf: '골프',
  taekwondo: '태권도',
  language: '언어',
  interpreter: '통역',
  translator: '번역',
  tour: '관광',
  english: '영어',
  conversation: '회화'
};

/**
 * 메인 한글 자격증명 변환 함수
 * @param {string} examKey - 영문 자격증 키
 * @returns {string} - 한글 자격증명
 */
export function getKoreanCertificationName(examKey) {
  if (!examKey || typeof examKey !== 'string') {
    return examKey || '';
  }

  // 1단계: 직접 매핑 테이블에서 찾기
  const directMapping = KOREAN_NAME_MAPPING[examKey];
  if (directMapping) {
    return directMapping;
  }

  // 2단계: 동적 규칙 적용
  for (const rule of DYNAMIC_MAPPING_RULES) {
    const match = examKey.match(rule.pattern);
    if (match) {
      const transformed = rule.transform(match);
      // 영어 단어들을 한국어로 변환
      return translateEnglishWords(transformed);
    }
  }

  // 3단계: 일반적인 변환 (하이픈으로 분리된 단어들)
  const words = examKey.split('-');
  const translatedWords = words.map(word => {
    return ENGLISH_TO_KOREAN_DICT[word.toLowerCase()] || word;
  });

  // 자격증 타입 자동 감지 및 추가
  const lastWord = words[words.length - 1];
  if (lastWord === 'engineer' && !translatedWords.includes('기사')) {
    translatedWords[translatedWords.length - 1] = '기사';
  } else if (lastWord === 'technician' && !translatedWords.includes('기능사')) {
    translatedWords[translatedWords.length - 1] = '기능사';
  }

  const result = translatedWords.join('');

  // 4단계: 최종 폴백 - 첫 글자만 대문자로 변환
  if (result === examKey) {
    return examKey
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return result;
}

/**
 * 한글 자격증명을 영문 키로 역변환하는 함수
 * @param {string} koreanName - 한글 자격증명
 * @returns {string} - 영문 자격증 키
 */
export function getEnglishKey(koreanName) {
  if (!koreanName || typeof koreanName !== 'string') {
    return koreanName || '';
  }

  // 직접 매핑 테이블에서 역방향 검색
  for (const [englishKey, korean] of Object.entries(KOREAN_NAME_MAPPING)) {
    if (korean === koreanName) {
      return englishKey;
    }
  }

  // 매핑을 찾지 못한 경우 원본 반환
  return koreanName;
}

/**
 * 영어 단어들을 한국어로 변환하는 헬퍼 함수
 * @param {string} text - 변환할 텍스트
 * @returns {string} - 변환된 텍스트
 */
function translateEnglishWords(text) {
  let result = text;
  
  // 영어 단어 패턴을 찾아서 한국어로 변환
  Object.entries(ENGLISH_TO_KOREAN_DICT).forEach(([english, korean]) => {
    const regex = new RegExp(english, 'gi');
    result = result.replace(regex, korean);
  });
  
  return result;
}

/**
 * 자격증 분류 카테고리 반환
 * @param {string} examKey - 영문 자격증 키
 * @returns {string} - 카테고리명
 */
export function getCertificationCategory(examKey) {
  if (!examKey) return '기타';
  
  const key = examKey.toLowerCase();
  
  if (key.includes('electrical') || key.includes('electronics') || key.includes('power')) {
    return CERTIFICATION_CATEGORIES.electrical;
  }
  if (key.includes('information') || key.includes('computer') || key.includes('network') || key.includes('web')) {
    return CERTIFICATION_CATEGORIES.it;
  }
  if (key.includes('construction') || key.includes('civil') || key.includes('architectural')) {
    return CERTIFICATION_CATEGORIES.construction;
  }
  if (key.includes('mechanical') || key.includes('automobile') || key.includes('welding')) {
    return CERTIFICATION_CATEGORIES.mechanical;
  }
  if (key.includes('chemical') || key.includes('environment') || key.includes('hazardous')) {
    return CERTIFICATION_CATEGORIES.chemical;
  }
  if (key.includes('safety') || key.includes('fire') || key.includes('industrial-safety')) {
    return CERTIFICATION_CATEGORIES.safety;
  }
  if (key.includes('operator') || key.includes('forklift') || key.includes('excavator')) {
    return CERTIFICATION_CATEGORIES.transportation;
  }
  if (key.includes('gas')) {
    return CERTIFICATION_CATEGORIES.gas;
  }
  if (key.includes('cooking') || key.includes('food') || key.includes('hotel') || key.includes('beauty')) {
    return CERTIFICATION_CATEGORIES.service;
  }
  if (key.includes('forest') || key.includes('agriculture') || key.includes('horticulture')) {
    return CERTIFICATION_CATEGORIES.agriculture;
  }
  
  return '기타';
}

/**
 * 자격증 레벨 추출 (기사, 산업기사, 기능사 등)
 * @param {string} examKey - 영문 자격증 키
 * @returns {string} - 자격증 레벨
 */
export function getCertificationLevel(examKey) {
  if (!examKey) return '';
  
  if (examKey.includes('industrial-engineer')) return '산업기사';
  if (examKey.includes('engineer')) return '기사';
  if (examKey.includes('technician')) return '기능사';
  if (examKey.includes('level1') || examKey.includes('level-1')) return '1급';
  if (examKey.includes('level2') || examKey.includes('level-2')) return '2급';
  if (examKey.includes('manager')) return '관리사';
  if (examKey.includes('instructor')) return '지도사';
  if (examKey.includes('teacher')) return '교사';
  if (examKey.includes('advisor')) return '상담사';
  
  return '';
}

/**
 * 사용자 정의 매핑 추가
 * @param {Object} customMappings - 사용자 정의 매핑 객체
 */
export function addCustomMappings(customMappings) {
  Object.assign(KOREAN_NAME_MAPPING, customMappings);
}

/**
 * 전체 매핑 테이블 반환 (디버깅용)
 * @returns {Object} - 전체 매핑 테이블
 */
export function getAllMappings() {
  return { ...KOREAN_NAME_MAPPING };
}

/**
 * 매핑 통계 반환
 * @returns {Object} - 매핑 통계 정보
 */
export function getMappingStatistics() {
  const categories = {};
  const levels = {};
  
  Object.keys(KOREAN_NAME_MAPPING).forEach(key => {
    const category = getCertificationCategory(key);
    const level = getCertificationLevel(key);
    
    categories[category] = (categories[category] || 0) + 1;
    if (level) {
      levels[level] = (levels[level] || 0) + 1;
    }
  });
  
  return {
    totalMappings: Object.keys(KOREAN_NAME_MAPPING).length,
    categories,
    levels,
    categoryCoverage: Object.keys(categories).length,
    levelCoverage: Object.keys(levels).length
  };
}

// 기존 examNameMapping과의 호환성을 위한 별칭
export const getKoreanExamName = getKoreanCertificationName;

// 기본 export
const koreanNameMapper = {
  KOREAN_NAME_MAPPING,
  CERTIFICATION_CATEGORIES,
  getKoreanCertificationName,
  getKoreanExamName: getKoreanCertificationName,
  getCertificationCategory,
  getCertificationLevel,
  addCustomMappings,
  getAllMappings,
  getMappingStatistics
};

export default koreanNameMapper;